import React from 'react';
import styles from './styles.module.css';
import history from 'store/history';

const AdminHome = () => {
  const datas = [
    {
      title: 'Monthly Goals',
      id: 1,
      link: '/admin/monthly-goals',
    },
    // {
    //   title: 'Daily Gympass Units',
    //   id: 2,
    //   link: '/admin/daily-gympass-units',
    // },
    {
      title: 'Wellhub Units',
      id: 2,
      link: '/admin/wellhub-units-history',
    },
  ];
  const goToLink = link => {
    history.push(link);
  };
  return (
    <>
      <div className={`${styles.wrapper}`}>
        {datas.map(data => {
          return (
            <div
              className={styles.card}
              key={data.id}
              onClick={() => goToLink(data.link)}
            >
              <p className={styles.text}>{data.title}</p>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default AdminHome;
